/** Mirrors P2PProviderOrderValidationCode on the backend. */
export enum PayinNotAssignedReason {
  NotFound = 'provider_not_found',
  Archived = 'provider_archived',
  PayinDisabled = 'provider_payin_disabled',
  NoTradeMethod = 'provider_no_trade_method',
  AmountOutOfRange = 'provider_amount_out_of_range',
  NotProfitable = 'provider_not_profitable',
  MaxBalanceExceeded = 'provider_max_balance_exceeded',
  DisputeLimitReached = 'provider_dispute_limit_reached',
  InvalidConfig = 'provider_invalid_config',
  AdapterNotFound = 'provider_adapter_not_found',
  DailyCustomerLimitReached = 'provider_daily_customer_limit_reached',
}
